import { render, staticRenderFns } from "./edit-post.vue?vue&type=template&id=5f018142&lang=pug&"
import script from "./edit-post.vue?vue&type=script&lang=js&"
export * from "./edit-post.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports